module.exports = __webpack_public_path__ + "static/media/png.832ce32c.svg";